var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progresBar"},[_c('div',{staticClass:"progress",style:({ width: _vm.progres+'%'})})])}
var staticRenderFns = []

export { render, staticRenderFns }